import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { CommonService } from 'src/app/services/Common-function/common.service';
import moment from 'moment';

@Component({
  selector: 'ipm-order-help-support',
  templateUrl: './order-help-support.component.html',
  styleUrls: ['./order-help-support.component.scss']
})
export class OrderHelpSupportComponent implements OnInit {
  @Input() currentOrderDetails: any = "";
  @Input() currentBeatData: any = "";
  @Input() orderType: string = "";
  headingText: string = "Help and Support";
  listOfOrdersSupport: Array<any> = [];
  daysLeft: number = 0;
  @Output() onOptionEventTrigger: EventEmitter<any> = new EventEmitter();

  constructor(public commonService: CommonService, private clipboard: Clipboard) { }

  ngOnInit(): void {
    this.createListOfOrdersSupport();
    if (this.currentOrderDetails?.createdAt) {
      this.daysLeft = this.getBusinessDaysLeft(this.currentOrderDetails?.createdAt);
    }
    if (this.orderType === 'studioOrder') {
      this.headingText = 'Seller Support';
    }
  }
  
  closePopup() {  
    this.commonService.closePopUp();
  }

  createListOfOrdersSupport() {
    if(this.orderType === 'studioOrder'){ 
      this.listOfOrdersSupport = [
        {
          title: 'Platform Related Support',
          key: "Platform_related_support",
          icon: `<img src="assets/imgs/platform-related.svg" alt="Platform Related Support Icon">`,
          isDisabled: false,
          subtext:"For queries related to order, downloads, licensing etc."
        }
      ];
    }else{
    this.listOfOrdersSupport = [
      {
        title: 'Dispute Purchase',
        key: "dispute_purchase",
        icon: `<img src="assets/imgs/dispute-purchase.svg" alt="Dispute Purchase Icon">`,
        isDisabled: false,
        subtext:"For problems related to audio files"
      },
      {
        title: 'Platform Related Support',
        key: "Platform_related_support",
        icon: `<img src="assets/imgs/platform-related.svg" alt="Platform Related Support Icon">`,
        isDisabled: false,
        subtext:"For queries related to order, downloads, licensing etc."
      }
    ];
    }
  }

  openClickOption(currentSelected: any) {
    this.closePopup();
    let sendData: any = {
      selectedOption: currentSelected,
      orderDetails: this.currentOrderDetails
    }
    this.onOptionEventTrigger.emit(sendData);
  }

  getBusinessDaysLeft(referenceDate: string | Date): number {
    const start = moment(referenceDate).startOf('day');
    const today = moment().startOf('day');

    let businessDaysPassed = 0;
    const current = start.clone();

    while (current.isBefore(today)) {
      const day = current.day(); // 0 = Sun, 6 = Sat

      if (day !== 0 && day !== 6) {
        businessDaysPassed++;
      }

      current.add(1, 'day');
    }

    return Math.max(14 - businessDaysPassed, 0);
  }
  copyEmailToClipboard(email: string) {
    if (!email) return;
    this.clipboard.copy(email);
  }
}
